import React from 'react'
import styled from 'styled-components'

export default function scrollToTop() {
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <ScrollWrapper
            className='fixed outline-none focus:outline-none'
            onClick={scrollTop}
            title='Scroll to top'
        >
            <svg
                xmlns='http://www.w3.org/2000/svg'
                fill='none'
                viewBox='0 0 24 24'
            >
                <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M5 10l7-7m0 0l7 7m-7-7v18'
                />
            </svg>
        </ScrollWrapper>
    )
}

const ScrollWrapper = styled.button`
    width: 1.5rem;
    right: 4rem;
    bottom: 5rem;
    transition: 0.5s linear;

    svg {
        stroke: #999;
    }

    svg:hover {
        stroke: rgba(0, 0, 0, 0.75);
    }

    @media (max-width: 768px) {
        display: none;
    }
`
